import { formState } from './index'
// 判断显示隐藏数据
export function filteHidden(key: string, data: formState[]) {
  const item = data.filter((item) => item.key === key)
  const length = item.length
  if (length >= 1) {
    if (item[length - 1].hidden === undefined) {
      return false
    }
    return item[length - 1].hidden
  }
  return false
}
// 判断禁用表单数据
export function filteDisabled(key: string, data: formState[]) {
  const item = data.filter((item) => item.key === key)
  const length = item.length
  if (length >= 1) {
    if (!item[length - 1].disabled) {
      return false
    }
    return item[length - 1].disabled
  }
  return false
}
import { formState } from './index'
// 判断显示隐藏数据
export function filteHidden(key: string, data: formState[]) {
  const item = data.filter((item) => item.key === key)
  const length = item.length
  if (length >= 1) {
    if (item[length - 1].hidden === undefined) {
      return false
    }
    return item[length - 1].hidden
  }
  return false
}
// 判断禁用表单数据
export function filteDisabled(key: string, data: formState[]) {
  const item = data.filter((item) => item.key === key)
  const length = item.length
  if (length >= 1) {
    if (!item[length - 1].disabled) {
      return false
    }
    return item[length - 1].disabled
  }
  return false
}
